import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, euro } from "@/lib/api";
import { STATUS_LABELS, statusColor } from "./Orders";
import { ArrowLeft, Phone, MessageSquare } from "lucide-react";

const STATUSES = ["recue", "confirmee", "appelee", "preparee", "livree", "retiree", "annulee"];

export default function OrderDetail() {
  const { orderId } = useParams();
  const [o, setO] = useState(null);
  const [notes, setNotes] = useState("");

  const load = () => api.get(`/admin/orders/${orderId}`).then(({ data }) => {
    setO(data); setNotes(data.notes || "");
  });
  useEffect(() => { load(); }, [orderId]);
  if (!o) return <p className="text-brand-green">Chargement…</p>;

  const changeStatus = async (status) => {
    await api.patch(`/admin/orders/${orderId}/status`, { status });
    toast.success(`Statut : ${STATUS_LABELS[status]}`); load();
  };
  const saveEdit = async () => {
    await api.patch(`/admin/orders/${orderId}`, { notes });
    toast.success("Enregistré"); load();
  };

  return (
    <div className="max-w-4xl">
      <Link to="/admin/commandes" className="inline-flex items-center gap-1 text-sm text-brand-green/60 mb-4"><ArrowLeft className="w-4 h-4" /> Réservations</Link>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <h1 className="font-serif text-3xl font-bold text-brand-green">{o.ref}</h1>
          <span className={`rounded-full px-3 py-1 text-xs font-semibold ${statusColor(o.status)}`}>{STATUS_LABELS[o.status]}</span>
        </div>
        <div className="flex gap-2">
          <a href={`tel:${(o.customer?.phone || "").replace(/\s/g, "")}`} data-testid="btn-call" className="inline-flex items-center gap-2 rounded-lg bg-brand-green text-white px-4 py-2 text-sm"><Phone className="w-4 h-4" /> Appeler</a>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border border-brand-green/10 p-5 space-y-2 text-sm">
          <h2 className="font-serif text-lg font-bold text-brand-green mb-2">Client &amp; livraison</h2>
          <div><span className="text-brand-green/60">Nom :</span> {o.customer?.name}</div>
          <div><span className="text-brand-green/60">Tél :</span> {o.customer?.phone}</div>
          <div><span className="text-brand-green/60">Email :</span> {o.customer?.email}</div>
          {o.customer?.company && <div><span className="text-brand-green/60">Société :</span> {o.customer.company}</div>}
          <div><span className="text-brand-green/60">Mode :</span> {o.mode}</div>
          {o.delivery && <div><span className="text-brand-green/60">Adresse :</span> {o.delivery.address} {o.delivery.postal_code ? `(${o.delivery.postal_code})` : ""}</div>}
          {o.delivery?.floor && <div><span className="text-brand-green/60">Étage :</span> {o.delivery.floor}</div>}
        </div>
        <div className="bg-white rounded-xl border border-brand-green/10 p-5 space-y-2 text-sm">
          <h2 className="font-serif text-lg font-bold text-brand-green mb-2">Détail</h2>
          {o.items?.map((it, i) => <div key={i} className="flex justify-between"><span>{it.quantity} × {it.name}</span><span>{euro(it.unit_price_ttc * it.quantity)}</span></div>)}
          <div className="flex justify-between border-t border-brand-green/10 pt-2 text-base"><span className="font-bold">Total à régler à la remise</span><span className="font-bold">{euro(o.product_total_ttc)}</span></div>
          <p className="text-xs text-brand-green/50">Règlement en espèces ou Revolut, convenu par téléphone.</p>
        </div>
      </div>

      {o.note && (
        <div className="bg-brand-gold/10 rounded-xl border border-brand-gold/30 p-5 mt-6" data-testid="customer-note">
          <h2 className="font-serif text-lg font-bold text-brand-green mb-2 flex items-center gap-2"><MessageSquare className="w-4 h-4 text-brand-gold" /> Note du client</h2>
          <p className="text-brand-green/80 whitespace-pre-wrap">{o.note}</p>
        </div>
      )}

      <div className="bg-white rounded-xl border border-brand-green/10 p-5 mt-6">
        <h2 className="font-serif text-lg font-bold text-brand-green mb-3">Changer le statut</h2>
        <div className="flex flex-wrap gap-2">
          {STATUSES.map((s) => (
            <button key={s} data-testid={`status-${s}`} onClick={() => changeStatus(s)} className={`rounded-full px-4 py-2 text-sm border ${o.status === s ? "bg-brand-green text-white" : "border-brand-green/20 text-brand-green hover:bg-brand-green/5"}`}>{STATUS_LABELS[s]}</button>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-xl border border-brand-green/10 p-5 mt-6">
        <h2 className="font-serif text-lg font-bold text-brand-green mb-3">Notes internes</h2>
        <textarea data-testid="edit-notes" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Notes internes (visibles uniquement par l'équipe)" className="w-full rounded-lg border border-brand-green/20 p-3 mb-3" rows={3} />
        <button data-testid="save-edit" onClick={saveEdit} className="rounded-lg bg-brand-gold text-brand-green px-5 py-2 font-semibold">Enregistrer</button>
      </div>
    </div>
  );
}
